import React from "react";
import NavbarTop from "../components/NavbarTop";
import NavbarBottom from "../components/NavbarBottom";
import StockList from "../components/StockList";

const Stock = () => {
  return (
    <div>
      <NavbarTop />
      <StockList />
      <NavbarBottom />
    </div>
  );
};

export default Stock;
